import { render, staticRenderFns } from "./AlignRight.vue?vue&type=template&id=2cafda08&scoped=true&"
var script = {}
import style0 from "./AlignRight.vue?vue&type=style&index=0&id=2cafda08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cafda08",
  null
  
)

export default component.exports